var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-badge"},[_vm._t("default"),_c('transition',{attrs:{"name":"el-zoom-in-center"}},[_c('sup',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSup),expression:"showSup"}],class:[
        'fixedRightTop',
        _vm.typeArr.includes(_vm.type) ? _vm.type : '',  /** 类型数组是否包含传进来的类型，包含就应用此类型样式，不包含就不应用类型样式 */
        _vm.isDot ? 'isDotClass' : '' ],domProps:{"textContent":_vm._s(_vm.showValue)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }